// CategorySelection.tsx - body-only item-group ("Category") filter, used on
// cross-category views (e.g. site-wide search results) where products span
// multiple item groups (Fabric, Wallpaper, Rugs, Homeware...). Header/accordion
// chrome lives in FilterSelection. Mirrors trade's PDF multifilter Category filter.
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { ChangeEvent } from 'react';

interface CategorySelectionProps {
  selectedCategories: string[];
  availableCategories: { [key: string]: string };
  onCategoryChange: (itemGroups: string[]) => void;
  isLoading?: boolean;
}

const CategorySelection = ({
  selectedCategories,
  availableCategories,
  onCategoryChange,
  isLoading = false,
}: CategorySelectionProps) => {
  const categories = Object.entries(availableCategories)
    .map(([itemGroup, name]) => ({ itemGroup, name }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleCategoryChange = (itemGroup: string) => (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const updatedCategories = isChecked
      ? [...selectedCategories, itemGroup]
      : selectedCategories.filter(cat => cat !== itemGroup);
    onCategoryChange(updatedCategories);
  };

  return (
    <Box>
      <FormGroup>
        {categories.map((category) => (
          <FormControlLabel
            key={category.itemGroup}
            control={
              <Checkbox
                checked={selectedCategories.includes(category.itemGroup)}
                onChange={handleCategoryChange(category.itemGroup)}
                disabled={isLoading}
              />
            }
            label={category.name}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default CategorySelection;
